import TableComponent from '../../../components/Table/TableComponent';
import "./ExaminationCommittee.scss";
import administration from "../../Administration.json";
import AboutUsDynamicPage from '../../Administration Dynamic Page/AdministrationdynamicPage';

const ExaminationCommittee = () => {

    const examinationCommittee = administration.examinationCommittee[0];
    const columns = ["S.No.", "Name", "Designation", "Members"];
    const rows = [
        { name: "Dr. R. Marimuthu", designation: "Principal", membership: "Chairman" },
        { name: "Mr. B. Sankar Gopu", designation: "Asst. Prof. & Head, Department of Computer Science(UG)", membership: "Member" },
        { name: "Mrs. L. B. Reshmi", designation: "Asst. Prof., Department of English", membership: "Member" },
        { name: "Dr. U. Josphin Benedit Bai", designation: "Asst. Prof. & Head, Department of Nutrition & Dietetics", membership: "Member" },
        { name: "Dr. D. Gananslin Sheeba", designation: "Asst. Prof., Department of Biotechnology", membership: "Member" },
        { name: "Dr. C. Murugesan", designation: "Asst. Prof. & Head, Department Mathematics", membership: "Member" },
        { name: "Mrs. K. Sreekala", designation: "Clerical Assistant", membership: "Member" },
        { name: "Mrs. B. P. Santhiya", designation: "Office Assistant", membership: "Member" },
    ];

    return (
        <section className="examinationCommitteeMainContainer">
            <AboutUsDynamicPage
                title={examinationCommittee.title}
                content={examinationCommittee.content}
                secondtitle={examinationCommittee.secondtitle}
                listitems={examinationCommittee.listitems}
            />
            <TableComponent
                columns={columns}
                data={rows}
                title="Examination Committee Member"
                gap='20px'
            />
        </section>
    )
}

export default ExaminationCommittee
